// extracted by mini-css-extract-plugin
module.exports = {"thresholdForm":"styles_thresholdForm__2Vw9V","title":"styles_title__l33sE","submit":"styles_submit__3XNO2"};